import { Component, Input } from '@angular/core';
import { IBallotInternalHistory } from '../../models/ballot-internal-history/ballot-internal-history';
import { ITableColumn, TableColumnType } from '../../../../controls/table/table-column';

@Component({
    selector: 'app-ballot-internal-history',
    templateUrl: './ballot-internal-history.component.html',
    styleUrl: './ballot-internal-history.component.scss',
    standalone: false
})
export class BallotInternalHistoryComponent {
   @Input() ballotInternalHistories: IBallotInternalHistory[] = [];
   @Input() isShowingCommentColumn = true;
   tableColumns: ITableColumn<IBallotInternalHistory>[] = []

  ngOnInit(): void {
    console.log(this.isShowingCommentColumn)
    this.initializeColumns();
  }

  initializeColumns() {
      const viewInternalHistoryTableColumns: ITableColumn<IBallotInternalHistory>[] = [
       {
         name: 'name',
         displayName: 'Name',
         type: TableColumnType.string,
       },
       {
         name: 'status',
         displayName: 'Status',
         type: TableColumnType.string,
       },
       {
         name: 'date',
         displayName: 'Date',
         type: TableColumnType.date,
       },
       {
         name: 'comments',
         displayName: 'Comments',
         type: TableColumnType.string,
         isHidden: !this.isShowingCommentColumn
       }
     ];
     this.tableColumns = viewInternalHistoryTableColumns;
  }

}
